import { render, staticRenderFns } from "./appCopyAsset.vue?vue&type=template&id=1b8be5f2&scoped=true"
import script from "./appCopyAsset.vue?vue&type=script&lang=js"
export * from "./appCopyAsset.vue?vue&type=script&lang=js"
import style0 from "./appCopyAsset.vue?vue&type=style&index=0&id=1b8be5f2&prod&lang=css"
import style1 from "./appCopyAsset.vue?vue&type=style&index=1&id=1b8be5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8be5f2",
  null
  
)

export default component.exports